import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCartShopping, faQuestion} from "@fortawesome/free-solid-svg-icons";
import {useDispatch} from "react-redux";
import {add} from "../Store/BorrowCart";
import {addBuy} from "../Store/BuyCart";
import {getTokenFromSession} from "../services/authenticate";
import config from "../Config/config";
import {useState} from "react";
import "../css/Price.css";
import {useNavigate} from "react-router-dom"; // Import the external CSS file

const Price = ({sellingPrice, book, condition, isbn}) => {
    const dispatch = useDispatch();
    const quantity = 1;

    const token = getTokenFromSession();
    const items = book;
    const [itemAdded, setItemAdded] = useState(false);

    const addcart = async (transaction_type) => {
        try {
            const response = await fetch(`${config.api.cart}`, {
                method: "POST",
                headers: {
                    "Content-Type": `application/json`,
                    Authorization: `${token}`,
                },
                body: JSON.stringify({
                    stock_id: book.stockId[0],
                    isbn: book.isbn,
                    transaction_type,
                    lending_days_count: transaction_type === "LENDING" ? 1 : 0,
                }),
            });
            // Briefly show "Item added to cart" message
            setItemAdded(true);
            setTimeout(() => {
                setItemAdded(false);
            }, 1000);

            if (!response.ok) {
                console.error(
                    "Error with transaction:",
                    transaction_type,
                    response.status
                );
            }
        } catch (error) {
            console.log("Error Message:", error.message);
        }
    };

    const navigate = useNavigate();
    const handleRentClick = () => {
        navigate(`/request/Rent/${isbn}`);
    }
    const handleBuyClick = () => {
        navigate(`/request/Buy/${isbn}`);
    }

    return (
        <div className="price-container">
            {itemAdded ? (
                <p className="item-added-msg">
                    <strong>Item added to cart!</strong>
                </p>
            ) : (
                <>
                    <div className="price-section">
                        <p className="price-text">
                            <strong>Mrp:</strong> <s>{book.mrp}</s>
                        </p>
                    </div>
                    {/* <div className="price-section">
                        <p className="price-text">
                            <strong>Borrow:</strong> ₹{lendingPricePerDay}
                            <span> /day</span>
                            {condition === "SOLD" ? (
                                <button className="cart-btn" onClick={handleRentClick}>
                                    <FontAwesomeIcon icon={faQuestion}/>
                                </button>
                            ) : (
                                <button
                                    onClick={() => {
                                        dispatch(add({items, quantity}));
                                        addcart("LENDING");
                                    }}
                                    className="cart-btn"
                                >
                                    <FontAwesomeIcon icon={faCartShopping}/>
                                </button>
                            )}
                        </p>
                    </div> */}
                    <div className="price-section">
                        <p className="price-text">
                            <strong>Buy:</strong> ₹{sellingPrice}
                            {condition === "SOLD" ? (
                                <button className="cart-btn" onClick={handleBuyClick}>
                                    <FontAwesomeIcon icon={faQuestion}/>
                                </button>
                            ) : (
                                <button
                                    onClick={() => {
                                        dispatch(addBuy({items, quantity}));
                                        addcart("PURCHASE");
                                    }}
                                    className="cart-btn"
                                >
                                    <FontAwesomeIcon icon={faCartShopping}/>
                                </button>
                            )}

                        </p>
                    </div>
                </>
            )}
        </div>
    );
};

export default Price;
